export default defineNuxtRouteMiddleware(async (to, from) => {
  const localePath = useLocalePath();
  const ignorePaths = ["/admin", "/under-maintenance"];
  if (!ignorePaths.some((x) => to.path.endsWith(x)) && useUserStore().role !== "ADMIN") {
    const { getMaintenanceStatus } = useAppStateStore();
    const data = await getMaintenanceStatus();
    if (data?.statusCode === 503)
      return navigateTo(localePath("/under-maintenance"));
  }
});
